<template>
  <div>
    <el-row type="flex" align="middle" :gutter="10">
      <el-col :span="16">
        <h3>Display Options</h3>
        <span class="description"
          >Manage display options for the competition -
          <br><br>
          <b>Public -</b> Whether the competition should be available for public viewing across applications<br>
          <b>Result -</b> Whether results should be available for public viewing across applications<br>
          <b>Ladders -</b> Whether ladders should be generated and displayed for this competition<br>
          <b>Team Lists -</b> Whether team lists for this competition is available for public viewing across applications
        </span>
      </el-col>
      <el-col :span="8" class="d-flex flex-justify-end">
        <el-button
          type="default"
          @click="$router.push({ name: 'competitions.list' })"
          >Close</el-button
        >
        <el-button type="primary" @click="submit">Update</el-button>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-form
      ref="form"
      :model="value"
      :rules="rules"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item prop="display.public" label="Public">
            <el-radio-group v-model="value.display.public">
              <el-radio-button :label="true">Yes</el-radio-button>
              <el-radio-button :label="false">No</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="display.result" label="Result">
            <el-radio-group v-model="value.display.result">
              <el-radio-button :label="true">Yes</el-radio-button>
              <el-radio-button :label="false">No</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="display.ladder" label="Ladder">
            <el-radio-group v-model="value.display.ladder">
              <el-radio-button :label="true">Yes</el-radio-button>
              <el-radio-button :label="false">No</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="display.teamlists" label="Teamlists">
            <el-radio-group v-model="value.display.teamlists">
              <el-radio-button :label="true">Yes</el-radio-button>
              <el-radio-button :label="false">No</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="display.liveTiming" v-if="!get(value, 'competitionSettings.useSetScoring', false)" label="Live Clock">
            <el-radio-group v-model="value.display.liveTiming">
              <el-radio-button :label="true">Yes</el-radio-button>
              <el-radio-button :label="false">No</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="4">
          <el-form-item prop="display.perPeriodScore" class="per-period-label" v-if="!get(value, 'competitionSettings.useSetScoring', false)" :label="`Display Per ${periodName} Score`">
            <el-radio-group v-model="value.display.perPeriodScore">
              <el-radio-button :label="true">Yes</el-radio-button>
              <el-radio-button :label="false">No</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="8">
          <el-form-item prop="display.nameFormat">
            <span slot="label">
              Manager Capture Name Format
              <el-tooltip class="item" effect="dark" placement="top-start">
                <div slot="content">Please select how you want the Manager capture screen to display name</div>
                <i class="el-icon-info info"/>
              </el-tooltip>
            </span>
            <el-select
              v-model="value.display.nameFormat"
              placeholder="E.g: Surname, Initial"
            >
              <el-option
                v-for="{ _id, name } in nameFormatOptions"
                :key="_id"
                :label="name"
                :value="_id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="12">
          <h3>Match Reminder</h3>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="6">
          <el-form-item prop="enableMatchReminder" label="Enable Match Reminder?">
            <el-radio-group v-model="value.display.enableMatchReminder">
              <el-radio-button :label="true">Yes</el-radio-button>
              <el-radio-button :label="false">No</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6" v-if="value.display.enableMatchReminder">
          <!-- Match reminder before hour -->
          <el-form-item prop="matchReminderBeforeHour" label="Hours Before Match">
            <el-input-number
              :min="0"
              v-model="value.display.matchReminderBeforeHour"
              :placeholder="24"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="12">
          <h3>Hide Individual Rounds</h3>
        </el-col>
        <el-col :span="12" class="d-flex flex-justify-end">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="dialogVisible = true"
            >Hide Dates</el-button
          >
        </el-col>
        <el-col :span="24">
          <el-table
            :data="value.display.hideRounds"
            class="mt-2"
          >
            <el-table-column
              prop="from"
              label="From"
              :formatter="dateFormatter"
            />
            <el-table-column prop="to" label="To" :formatter="dateFormatter" />
            <el-table-column align="right">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  icon="el-icon-remove-outline"
                  @click="removeSkipDate(scope.$index)"
                  >Remove</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      :show-close="true"
      :visible="dialogVisible"
      width="30%"
    >
      <template v-slot:title>
        <h3>Add Date Range</h3>
        <span class="description"
          >Create a new date range during which matches will not be displayed.
        </span>
      </template>
      <el-form
        ref="hideDateRangeFrm"
        :model="skipDate"
        :rules="skipDateRules"
        label-position="top"
      >
        <el-form-item label="Date Range" prop="dates">
          <el-date-picker
            type="daterange"
            range-separator="-"
            start-placeholder="Start date"
            end-placeholder="End date"
            v-model="skipDate.dates"
            placeholder=""
            value-format="timestamp"
            :format="timedateObj().formDateFormat"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="addDateRange">Add</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import {
//   errormsg,
} from '@/utils/constants';
import { timedate } from '@/utils/timedate';
import _, { cloneDeep } from 'lodash';

export default {
  name: 'CompDisplayOptions',
  props: ['value'],
  data() {
    return {
      get: _.get,
      venues: [],
      compTypes: [],
      dialogVisible: false,
      skipDate: {
        dates: undefined
      },
      skipDateRules: {
        dates: {
          required: true,
          trigger: 'change'
        }
      },
      rules: {
      },
      nameFormatOptions: [
        {
          _id: 0,
          name: 'Surname, First Name Initial'
        },
        {
          _id: 1,
          name: 'First Name, Surname Initial'
        },
        {
          _id: 2,
          name: 'Jersey No:  Surname, First Name Initial'
        },
        {
          _id: 3,
          name: 'Jersey No:  First Name, Surname Initial'
        }
      ]
    };
  },
  mounted() {
  },
  methods: {
    timedateObj() {
      return timedate;
    },
    dateFormatter(r, c, val) {
      return timedate.set(val).fDate();
    },
    removeSkipDate(index) {
      this.$confirm('Are you sure you want to remove this date?', 'Warning')
        .then(() => {
          this.value.display.hideRounds.splice(index, 1);
        })
        .catch(() => {});
    },
    addDateRange() {
      this.$refs.hideDateRangeFrm.validate()
        .then((val) => {
          if (val) {
            const [from, to] = cloneDeep(this.skipDate.dates);
            const isOverlapping = _.some(this.value.display.hideRounds, (d) => !(d.from > to || d.to < from));
            if (isOverlapping) {
              this.$message.error('Overlapping date range');
              return;
            }
            this.value.display.hideRounds.push({ from, to });
            this.closeDialog();
          }
        }).catch(() => {});
    },
    closeDialog() {
      this.$refs.hideDateRangeFrm.resetFields();
      this.dialogVisible = false;
    },
    submit() {
      const { id } = this.$route.params;
      this.$store.commit('loading', true);
      this.$http.put(`assemble/api/v1/admin/competitions/${id}`, { display: this.value.display })
        .then(() => {
          this.$emit('input', this.value);
          this.$message.success('Successful');
          this.$store.commit('loading', false);
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
          this.$store.commit('loading', false);
        });
    }
  },
  computed: {
    clearance() {
      return this.$store.getters['user/activeRoleType'];
    },
    periodName() {
      if (this.value.periodType === 4) return 'Quarter';
      if (this.value.periodType === 2) return 'Half';
      return 'Period';
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding-top: 0;
}

.per-period-label {
  width: 157px;
}
</style>
